import React, { useState, useEffect } from "react";



import { useParams, useNavigate } from "react-router-dom";
import {
    query,
    where,
    getDocs,
    collection,
    doc,
    updateDoc,
} from "firebase/firestore";
import {
    getStorage,
    ref as storageRef,
    uploadBytes,
    getDownloadURL,
} from "firebase/storage";
import db from "./Firebase";
import Swal from "sweetalert2";
import moment from "moment";

function ModifyLoanDetails() {
    const { id } = useParams(); // expecting URL like /user_loan_details/:id where id = username
    const navigate = useNavigate();

    const [loanData, setLoanData] = useState(null);
    const [docId, setDocId] = useState(null);
    const [formState, setFormState] = useState({});
    const [initialState, setInitialState] = useState({});
    const [loading, setLoading] = useState(true);
    const [filesToUpload, setFilesToUpload] = useState({});
    const storage = getStorage();

    useEffect(() => {
        async function fetchLoan() {
            try {
                const q = query(collection(db, "nv_loan"), where("username", "==", id));
                const snap = await getDocs(q);
                if (snap.empty) {
                    Swal.fire("Error", "Loan not found", "error");
                    navigate("/");
                    return;
                }
                const docSnap = snap.docs[0];
                setDocId(docSnap.id);
                const data = docSnap.data();
                setLoanData(data);
                setFormState(data);
                setInitialState(data);
                setLoading(false);
            } catch (err) {
                console.error("Fetch error", err);
                Swal.fire("Error", "Failed to load loan data", "error");
                setLoading(false);
            }
        }
        fetchLoan();
    }, [id, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files && files.length > 0) {
            setFilesToUpload((prev) => ({
                ...prev,
                [name]: files[0],
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!docId) {
            Swal.fire("Error", "Document not loaded", "error");
            return;
        }

        const updates = {};

        // Compare non-file fields
        for (const key in formState) {
            if (!formState.hasOwnProperty(key)) continue;
            if (filesToUpload[key]) continue; // skip if file is being replaced
            const newVal = formState[key];
            const oldVal = initialState[key];
            if (newVal !== oldVal) {
                updates[key] = newVal;
            }
        }

        // Upload changed files
        for (const field in filesToUpload) {
            const file = filesToUpload[field];
            const fileRef = storageRef(
                storage,
                `loanfiles/${field}_${Date.now()}_${file.name}`
            );
            try {
                const snapshot = await uploadBytes(fileRef, file);
                const url = await getDownloadURL(snapshot.ref);
                updates[field] = url;
            } catch (err) {
                console.error(`Failed to upload ${field}`, err);
                Swal.fire("Error", `Failed to upload ${field}`, "error");
                return;
            }
        }

        if (Object.keys(updates).length === 0) {
            Swal.fire("Info", "No changes to update", "info");
            return;
        }

        try {
            const docRef = doc(db, "nv_loan", docId);
            await updateDoc(docRef, updates);
            Swal.fire("Success", "Loan data updated successfully", "success");
            // Refresh
            setInitialState((prev) => ({ ...prev, ...updates }));
            setLoanData((prev) => ({ ...prev, ...updates }));
            setFilesToUpload({});
        } catch (err) {
            console.error("Update error", err);
            Swal.fire("Error", "Failed to update loan data", "error");
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "2rem" }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-4">
            <div className="card shadow-sm">
                <div className="card-header bg-info text-white">
                    <h3>Modify Loan Details for {id}</h3>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        {/* Document/image fields */}
                        <div className="row">
                            {[
                                "Aadhar_Front",
                                "Aadhar_Back",
                                "Pan_Card",
                                "Passbook_Front",
                                "Passportsize_Photo",
                                "Bank_Statement",
                                "Building_Front_Image",
                                "Building_Interior_Image",
                                "Business_Video",
                            ].map((field) => (
                                <div className="col-md-4 mb-4" key={field}>
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <label className="form-label fw-bold">
                                                {field.replace(/_/g, " ")}
                                            </label>
                                            <div className="mb-2">
                                                {formState[field] ? (
                                                    <img
                                                        src={formState[field]}
                                                        alt={field}
                                                        style={{
                                                            width: "100%",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "4px",
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            height: "150px",
                                                            backgroundColor: "#f0f0f0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "#888",
                                                            borderRadius: "4px",
                                                        }}
                                                    >
                                                        No Preview
                                                    </div>
                                                )}
                                            </div>
                                            {/* <input
                                                type="file"
                                                name={field}
                                                accept="image/*,video/*"
                                                className="form-control form-control-sm"
                                                onChange={handleFileChange}
                                            /> */}
                                            <input
                                                type="file"
                                                name={field}
                                                className="form-control form-control-sm"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {[
                                { name: "aadhar_number", label: "Aadhar Number", type: "text" },
                                { name: "aboutThisLoan", label: "About This Loan", type: "text" },
                                { name: "address", label: "Address", type: "text" },
                                { name: "alternateIncome", label: "Alternate Income", type: "text" },
                                { name: "alternate_phone_no", label: "Alternate Phone No", type: "text" },
                                { name: "bankAccountNumber", label: "Bank Account Number", type: "text" },
                                { name: "bankName", label: "Bank Name", type: "text" },
                                { name: "businessEstablishedYear", label: "Business Established Year", type: "text" },
                                { name: "businessName", label: "Business Name", type: "text" },
                                { name: "businessType", label: "Business Type", type: "text" },
                                { name: "city", label: "City", type: "text" },
                                { name: "dob", label: "Date of Birth", type: "date" },
                                { name: "education", label: "Education", type: "text" },
                                { name: "estimatedPrice", label: "Estimated Price", type: "text" },
                                { name: "fatherName", label: "Father's Name", type: "text" },
                                { name: "fullName", label: "Full Name", type: "text" },
                                { name: "gender", label: "Gender", type: "text" },
                                { name: "ifscCode", label: "IFSC Code", type: "text" },
                                { name: "loanAmount", label: "Loan Amount", type: "text" },
                                { name: "maritalStatus", label: "Marital Status", type: "text" },
                                { name: "monthlyIncome", label: "Monthly Income", type: "text" },
                                { name: "motherName", label: "Mother's Name", type: "text" },
                                { name: "nameOfEqupiment", label: "Name of Equipment", type: "text" },
                                { name: "pan_number", label: "PAN Number", type: "text" },
                                { name: "pincode", label: "Pincode", type: "text" },
                                { name: "secondary_occupation", label: "Secondary Occupation", type: "text" },
                                { name: "selected_emi_plan", label: "Selected EMI Plan", type: "number" },
                                { name: "state", label: "State", type: "text" },
                                { name: "takenPastLoan", label: "Taken Past Loan", type: "text" },
                                { name: "uid", label: "UID", type: "text" },
                                { name: "uipId", label: "UPI ID", type: "text" },
                                { name: "username", label: "Username", type: "text" },
                                { name: "whyNeedGrant", label: "Why Need Grant", type: "text" },
                            ].map((field, idx) => (
                                <div className="col-md-6 mb-4" key={field.name}>
                                    <div className="form-floating">
                                        <input
                                            type={field.type}
                                            name={field.name}
                                            id={field.name}
                                            className="form-control"
                                            placeholder={field.label}
                                            value={formState[field.name] || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor={field.name}>{field.label}</label>
                                    </div>
                                </div>
                            ))}
                        </div>


                        {/* Submit */}
                        <div className="d-flex justify-content-end mt-4">
                            <button type="submit" className="btn btn-success btn-lg">
                                Update Changes
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModifyLoanDetails;



// import React, { useState, useEffect } from "react";


// import { useParams, useNavigate } from "react-router-dom";
// import { query, where, getDocs, collection, doc, updateDoc } from "firebase/firestore";
// import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
// import db from "./Firebase";
// import Swal from "sweetalert2";
// import moment from "moment";

// function ModifyLoanDetails() {
//     const { id } = useParams(); // expecting URL like /user_loan_details/:id where id = username
//     const navigate = useNavigate();

//     const [loanData, setLoanData] = useState(null);
//     const [docId, setDocId] = useState(null);
//     const [formState, setFormState] = useState({});
//     const [initialState, setInitialState] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [filesToUpload, setFilesToUpload] = useState({});
//     // e.g. { Aadhar_Front: File, Pan_Card: File, Business_Video: File, etc }

//     const storage = getStorage();

//     useEffect(() => {
//         async function fetchLoan() {
//             try {
//                 const q = query(collection(db, "nv_loan"), where("username", "==", id));
//                 const snap = await getDocs(q);
//                 if (snap.empty) {
//                     Swal.fire("Error", "Loan not found", "error");
//                     navigate("/");
//                     return;
//                 }
//                 const docSnap = snap.docs[0];
//                 setDocId(docSnap.id);
//                 const data = docSnap.data();
//                 setLoanData(data);
//                 setFormState(data);
//                 setInitialState(data);
//                 setLoading(false);
//             } catch (err) {
//                 console.error("Fetch error", err);
//                 Swal.fire("Error", "Failed to load loan data", "error");
//                 setLoading(false);
//             }
//         }
//         fetchLoan();
//     }, [id, navigate]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormState(prev => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const handleFileChange = (e) => {
//         const { name, files } = e.target;
//         if (files && files.length > 0) {
//             setFilesToUpload(prev => ({
//                 ...prev,
//                 [name]: files[0],
//             }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!docId) {
//             Swal.fire("Error", "Document not loaded", "error");
//             return;
//         }

//         const updates = {};

//         // 1. Primitive / non-file fields
//         for (const key in formState) {
//             if (!formState.hasOwnProperty(key)) continue;
//             if (filesToUpload[key]) continue;  // we'll handle file fields separately
//             const newVal = formState[key];
//             const oldVal = initialState[key];
//             // For date strings, you may want to normalize before compare
//             if (newVal !== oldVal) {
//                 updates[key] = newVal;
//             }
//         }

//         // 2. File uploads
//         for (const field in filesToUpload) {
//             const file = filesToUpload[field];
//             const fileRef = storageRef(storage, `loanfiles/${field}_${Date.now()}_${file.name}`);
//             try {
//                 const snapshot = await uploadBytes(fileRef, file);
//                 const url = await getDownloadURL(snapshot.ref);
//                 updates[field] = url;
//             } catch (err) {
//                 console.error(`Failed to upload ${field}`, err);
//                 Swal.fire("Error", `Failed to upload ${field}`, "error");
//                 return;
//             }
//         }

//         if (Object.keys(updates).length === 0) {
//             Swal.fire("Info", "No changes to update", "info");
//             return;
//         }

//         try {
//             const docRef = doc(db, "nv_loan", docId);
//             await updateDoc(docRef, updates);
//             Swal.fire("Success", "Loan data updated successfully", "success");
//             // Refresh state
//             setInitialState(prev => ({ ...prev, ...updates }));
//             setLoanData(prev => ({ ...prev, ...updates }));
//             setFilesToUpload({});
//         } catch (err) {
//             console.error("Update error", err);
//             Swal.fire("Error", "Failed to update loan data", "error");
//         }
//     };

//     if (loading) return <div>Loading...</div>;

//     return (
//         <div className="container my-4">
//             <h2>Modify Loan Details for {id}</h2>
//             <form onSubmit={handleSubmit}>
//                 {/* Document/image fields */}
//                 {["Aadhar_Front", "Aadhar_Back", "Pan_Card", "Passbook_Front", "Passportsize_Photo",
//                     "Bank_Statement", "Building_Front_Image", "Building_Interior_Image",
//                     "Business_Video"].map((field) => (
//                         <div className="mb-3" key={field}>
//                             <label>{field.replace(/_/g, " ")}</label>
//                             <div>
//                                 {formState[field] && (
//                                     <img
//                                         src={formState[field]}
//                                         alt={field}
//                                         style={{ width: 150, marginBottom: 8 }}
//                                     />
//                                 )}
//                             </div>
//                             <input
//                                 type="file"
//                                 name={field}
//                                 accept="image/*,video/*"
//                                 onChange={handleFileChange}
//                             />
//                         </div>
//                     ))}

//                 {/* Other text / number / dropdown fields */}
//                 {/* <div className="mb-3">
//                     <label>Aadhar Number</label>
//                     <input
//                         type="text"
//                         name="aadhar_number"
//                         className="form-control"
//                         value={formState.aadhar_number || ""}
//                         onChange={handleChange}
//                     />
//                 </div> */}

//                 {/* <div className="mb-3">
//                     <label>Full Name</label>
//                     <input
//                         type="text"
//                         name="fullName"
//                         className="form-control"
//                         value={formState.fullName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Business Type</label>
//                     <input
//                         type="text"
//                         name="businessType"
//                         className="form-control"
//                         value={formState.businessType || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Business Name</label>
//                     <input
//                         type="text"
//                         name="businessName"
//                         className="form-control"
//                         value={formState.businessName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Loan Amount</label>
//                     <input
//                         type="number"
//                         name="loanAmount"
//                         className="form-control"
//                         value={formState.loanAmount || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Selected EMI Plan</label>
//                     <input
//                         type="number"
//                         name="selected_emi_plan"
//                         className="form-control"
//                         value={formState.selected_emi_plan || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Estimated Price</label>
//                     <input
//                         type="number"
//                         name="estimatedPrice"
//                         className="form-control"
//                         value={formState.estimatedPrice || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Why Need Grant</label>
//                     <input
//                         type="text"
//                         name="whyNeedGrant"
//                         className="form-control"
//                         value={formState.whyNeedGrant || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Payment Link</label>
//                     <input
//                         type="text"
//                         name="payment_link"
//                         className="form-control"
//                         value={formState.payment_link || ""}
//                         onChange={handleChange}
//                     />
//                 </div> */}


//                 <div className="mb-3">
//                     <label>Aadhar Number</label>
//                     <input
//                         type="text"
//                         name="aadhar_number"
//                         className="form-control"
//                         value={formState.aadhar_number || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>About This Loan</label>
//                     <input
//                         type="text"
//                         name="aboutThisLoan"
//                         className="form-control"
//                         value={formState.aboutThisLoan || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Address</label>
//                     <input
//                         type="text"
//                         name="address"
//                         className="form-control"
//                         value={formState.address || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Alternate Income</label>
//                     <input
//                         type="text"
//                         name="alternateIncome"
//                         className="form-control"
//                         value={formState.alternateIncome || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Alternate Phone No</label>
//                     <input
//                         type="text"
//                         name="alternate_phone_no"
//                         className="form-control"
//                         value={formState.alternate_phone_no || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Bank Account Number</label>
//                     <input
//                         type="text"
//                         name="bankAccountNumber"
//                         className="form-control"
//                         value={formState.bankAccountNumber || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Bank Name</label>
//                     <input
//                         type="text"
//                         name="bankName"
//                         className="form-control"
//                         value={formState.bankName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Business Established Year</label>
//                     <input
//                         type="text"
//                         name="businessEstablishedYear"
//                         className="form-control"
//                         value={formState.businessEstablishedYear || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Business Name</label>
//                     <input
//                         type="text"
//                         name="businessName"
//                         className="form-control"
//                         value={formState.businessName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Business Type</label>
//                     <input
//                         type="text"
//                         name="businessType"
//                         className="form-control"
//                         value={formState.businessType || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>City</label>
//                     <input
//                         type="text"
//                         name="city"
//                         className="form-control"
//                         value={formState.city || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Date of Birth</label>
//                     <input
//                         type="date"
//                         name="dob"
//                         className="form-control"
//                         value={formState.dob || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Education</label>
//                     <input
//                         type="text"
//                         name="education"
//                         className="form-control"
//                         value={formState.education || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Estimated Price</label>
//                     <input
//                         type="text"
//                         name="estimatedPrice"
//                         className="form-control"
//                         value={formState.estimatedPrice || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Father's Name</label>
//                     <input
//                         type="text"
//                         name="fatherName"
//                         className="form-control"
//                         value={formState.fatherName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Full Name</label>
//                     <input
//                         type="text"
//                         name="fullName"
//                         className="form-control"
//                         value={formState.fullName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Gender</label>
//                     <input
//                         type="text"
//                         name="gender"
//                         className="form-control"
//                         value={formState.gender || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>IFSC Code</label>
//                     <input
//                         type="text"
//                         name="ifscCode"
//                         className="form-control"
//                         value={formState.ifscCode || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Loan Amount</label>
//                     <input
//                         type="text"
//                         name="loanAmount"
//                         className="form-control"
//                         value={formState.loanAmount || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Marital Status</label>
//                     <input
//                         type="text"
//                         name="maritalStatus"
//                         className="form-control"
//                         value={formState.maritalStatus || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Monthly Income</label>
//                     <input
//                         type="text"
//                         name="monthlyIncome"
//                         className="form-control"
//                         value={formState.monthlyIncome || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Mother's Name</label>
//                     <input
//                         type="text"
//                         name="motherName"
//                         className="form-control"
//                         value={formState.motherName || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Name of Equipment</label>
//                     <input
//                         type="text"
//                         name="nameOfEqupiment"
//                         className="form-control"
//                         value={formState.nameOfEqupiment || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>PAN Number</label>
//                     <input
//                         type="text"
//                         name="pan_number"
//                         className="form-control"
//                         value={formState.pan_number || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Pincode</label>
//                     <input
//                         type="text"
//                         name="pincode"
//                         className="form-control"
//                         value={formState.pincode || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Secondary Occupation</label>
//                     <input
//                         type="text"
//                         name="secondary_occupation"
//                         className="form-control"
//                         value={formState.secondary_occupation || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Selected EMI Plan</label>
//                     <input
//                         type="number"
//                         name="selected_emi_plan"
//                         className="form-control"
//                         value={formState.selected_emi_plan || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>State</label>
//                     <input
//                         type="text"
//                         name="state"
//                         className="form-control"
//                         value={formState.state || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Taken Past Loan</label>
//                     <input
//                         type="text"
//                         name="takenPastLoan"
//                         className="form-control"
//                         value={formState.takenPastLoan || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>UID</label>
//                     <input
//                         type="text"
//                         name="uid"
//                         className="form-control"
//                         value={formState.uid || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>UPI ID</label>
//                     <input
//                         type="text"
//                         name="uipId"
//                         className="form-control"
//                         value={formState.uipId || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Username</label>
//                     <input
//                         type="text"
//                         name="username"
//                         className="form-control"
//                         value={formState.username || ""}
//                         onChange={handleChange}
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label>Why Need Grant</label>
//                     <input
//                         type="text"
//                         name="whyNeedGrant"
//                         className="form-control"
//                         value={formState.whyNeedGrant || ""}
//                         onChange={handleChange}
//                     />
//                 </div>


//                 {/* Add the rest of the non-doc fields similarly */}
//                 {/* e.g. monthlyIncome, secondary_occupation, address, etc */}

//                 <button type="submit" className="btn btn-primary mt-3">
//                     Update Changes
//                 </button>
//             </form>
//         </div>
//     );
// }

// export default ModifyLoanDetails;

// // import React, { useState, useEffect } from "react";


// // import { useParams, useNavigate } from "react-router-dom";
// // import { doc, updateDoc, getDocs, query, where, collection } from "firebase/firestore";
// // import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
// // import db from "./Firebase";
// // import Swal from "sweetalert2";
// // import moment from "moment";

// // function ModifyLoanDetails() {
// //     const { id } = useParams();
// //     const navigate = useNavigate();

// //     const [loanData, setLoanData] = useState(null);
// //     const [docId, setDocId] = useState(null);
// //     const [formState, setFormState] = useState({});
// //     const [initialState, setInitialState] = useState({});
// //     const [loading, setLoading] = useState(true);
// //     const [filesToUpload, setFilesToUpload] = useState({});
// //     // e.g. { Aadhar_Front: File, Pan_Card: File, ... }

// //     const storage = getStorage(); // assuming firebase v9 modular

// //     useEffect(() => {
// //         async function fetchLoan() {
// //             try {
// //                 const q = query(collection(db, "nv_loan"), where("username", "==", id));
// //                 const snap = await getDocs(q);
// //                 if (snap.empty) {
// //                     Swal.fire("Error", "Loan not found", "error");
// //                     navigate("/"); return;
// //                 }
// //                 const docSnap = snap.docs[0];
// //                 setDocId(docSnap.id);
// //                 const data = docSnap.data();
// //                 setLoanData(data);
// //                 setFormState(data);
// //                 setInitialState(data);
// //                 setLoading(false);
// //             } catch (err) {
// //                 console.error("Fetch error", err);
// //                 Swal.fire("Error", "Failed to load loan data", "error");
// //                 setLoading(false);
// //             }
// //         }
// //         fetchLoan();
// //     }, [id, navigate]);

// //     const handleChange = (e) => {
// //         const { name, value } = e.target;
// //         setFormState((prev) => ({
// //             ...prev,
// //             [name]: value,
// //         }));
// //     };

// //     const handleFileChange = (e) => {
// //         const { name, files } = e.target;
// //         if (files.length > 0) {
// //             setFilesToUpload((prev) => ({
// //                 ...prev,
// //                 [name]: files[0],
// //             }));
// //         }
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         if (!docId) {
// //             Swal.fire("Error", "Document not loaded", "error");
// //             return;
// //         }

// //         const updates = {};

// //         // 1. Compare primitive fields / non-file fields
// //         for (const key in formState) {
// //             if (!formState.hasOwnProperty(key)) continue;
// //             // Skip document URL fields for now
// //             if (filesToUpload[key]) continue;
// //             const newVal = formState[key];
// //             const oldVal = initialState[key];
// //             // If dates, convert etc as needed
// //             if (newVal !== oldVal) {
// //                 updates[key] = newVal;
// //             }
// //         }

// //         // 2. Handle files upload
// //         for (const fileField in filesToUpload) {
// //             const file = filesToUpload[fileField];
// //             // upload to storage
// //             const fileRef = storageRef(storage, `loanfiles/${fileField}_${Date.now()}_${file.name}`);
// //             try {
// //                 const snapshot = await uploadBytes(fileRef, file);
// //                 const url = await getDownloadURL(snapshot.ref);
// //                 updates[fileField] = url;
// //             } catch (err) {
// //                 console.error(`Failed to upload ${fileField}`, err);
// //                 Swal.fire("Error", `Failed to upload ${fileField}`, "error");
// //                 return;
// //             }
// //         }

// //         if (Object.keys(updates).length === 0) {
// //             Swal.fire("Info", "No changes to update", "info");
// //             return;
// //         }

// //         try {
// //             const docRef = doc(db, "nv_loan", docId);
// //             await updateDoc(docRef, updates);
// //             Swal.fire("Success", "Loan data updated successfully", "success");
// //             // Optionally refresh
// //             setInitialState((prev) => ({ ...prev, ...updates }));
// //             setLoanData((prev) => ({ ...prev, ...updates }));
// //             setFilesToUpload({});
// //         } catch (err) {
// //             console.error("Update error", err);
// //             Swal.fire("Error", "Failed to update loan data", "error");
// //         }
// //     };

// //     if (loading) return <div>Loading...</div>;

// //     return (
// //         <div className="container my-4">
// //             <h2>Modify Loan Details for {id}</h2>
// //             <form onSubmit={handleSubmit}>
// //                 {/* Example: Text fields */}
// //                 <div className="mb-3">
// //                     <label>Full Name</label>
// //                     <input
// //                         type="text"
// //                         name="fullName"
// //                         className="form-control"
// //                         value={formState.fullName || ""}
// //                         onChange={handleChange}
// //                     />
// //                 </div>

// //                 <div className="mb-3">
// //                     <label>Business Name</label>
// //                     <input
// //                         type="text"
// //                         name="businessName"
// //                         className="form-control"
// //                         value={formState.businessName || ""}
// //                         onChange={handleChange}
// //                     />
// //                 </div>

// //                 {/* Document fields */}
// //                 <div className="mb-3">
// //                     <label>Aadhar Front</label>
// //                     <div>
// //                         <img src={formState.Aadhar_Front} alt="Aadhar Front" style={{ width: 150 }} />
// //                     </div>
// //                     <input
// //                         type="file"
// //                         name="Aadhar_Front"
// //                         accept="image/*"
// //                         onChange={handleFileChange}
// //                     />
// //                 </div>

// //                 <div className="mb-3">
// //                     <label>PAN Card</label>
// //                     <div>
// //                         <img src={formState.Pan_Card} alt="PAN Card" style={{ width: 150 }} />
// //                     </div>
// //                     <input
// //                         type="file"
// //                         name="Pan_Card"
// //                         accept="image/*"
// //                         onChange={handleFileChange}
// //                     />
// //                 </div>

// //                 {/* Repeat for other document fields similarly... */}

// //                 {/* Any other fields */}
// //                 <div className="mb-3">
// //                     <label>Monthly Income</label>
// //                     <input
// //                         type="number"
// //                         name="monthlyIncome"
// //                         className="form-control"
// //                         value={formState.monthlyIncome || ""}
// //                         onChange={handleChange}
// //                     />
// //                 </div>

// //                 {/* ... more fields as needed ... */}

// //                 <button type="submit" className="btn btn-primary mt-3">
// //                     Update Changes
// //                 </button>
// //             </form>
// //         </div>
// //     );
// // }

// // export default ModifyLoanDetails;
